/**
 * index.js
 *
 * Purpose:
 * - Entry point for the React application.
 * - Render the App component to the DOM.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import AppBoot from './components/AppBoot';
import AppErrorBoundary from './components/AppErrorBoundary';
import { FRONTEND_BUILD_COMMIT } from './services/buildInfo';
// GH #179: AppBoot gates <App/> behind a health-check poll so a sleeping
// Render backend shows a friendly "waking up" screen instead of a blank/hung
// page on cold start. See components/AppBoot.js.

// #224 — log the running build's commit once on boot (see Settings > Profile
// for the live UI surface, which also fetches the backend's own commit).
 
console.info(`[RMDV] frontend build commit: ${FRONTEND_BUILD_COMMIT}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
// #1020 finding 21: outside every provider on purpose — a boundary inside the
// theme or the router cannot catch that provider's own render error.
root.render(
  <AppErrorBoundary>
    <AppBoot />
  </AppErrorBoundary>
);
